import { Injectable } from "@angular/core";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { DeviceConfigService } from "@obg/ngx.global";
import { map } from "rxjs/operators";

import { COMPLETE_ACCOUNT_LOGIN_DIALOG_ID } from "../../login-flow-dialog/login-flow-dialog.const";

import { CompleteAccountLoginContainer } from "./complete-account-login.container";

@Injectable({
	providedIn: "root",
})
export class CompleteAccountLoginDialogService {
	constructor(
		private dialogService: DialogService,
		private deviceConfigService: DeviceConfigService
	) {}

	COMPLETE_ACCOUNT_LOGIN_DIALOG: DialogLike<CompleteAccountLoginContainer> = {
		dialogId: COMPLETE_ACCOUNT_LOGIN_DIALOG_ID,
		dialogComponentType: CompleteAccountLoginContainer,
		onClose$: (c) => c.close,
		onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
	};

	open = () =>
		this.dialogService.openComponent(this.COMPLETE_ACCOUNT_LOGIN_DIALOG, {
			panelClass: "complete-account-login-dialog",
			width: this.deviceConfigService.isDesktop() ? "initial" : "100dvw",
			height: this.deviceConfigService.isDesktop() ? "initial" : "100dvh",
			disableClose: true,
			autoFocus: false,
			data: {
				hideClose: true,
				hideFooter: true,
			},
		});
}
